<div class="preview-dialog" [style.minHeight]="height + 'px'" [style.width]="'calc(100% - 810px)'">
    <div class="preview-dialog-header">
        <div class="action">
            <button class="color-primary" nz-button nzType="text" (click)="zoomIn()">
                <span nz-icon nzType="zoom-in" nzTheme="outline"></span>
            </button>
            <button class="color-primary" nz-button nzType="text">
                <span nz-icon nzType="border-outer" nzTheme="outline" (click)="originSize()"></span>
            </button>
            <button class="color-primary" nz-button nzType="text" (click)="zoomOut()">
                <span nz-icon nzType="zoom-out" nzTheme="outline"></span>
            </button>
        </div>
    </div>

    <div class="preview-dialog-body">
        <pdf-viewer [src]="environment.fileHost + currentFile.fileId + withToken" [c-maps-url]="'/assets/cmaps/'"
            [render-text]="true" [zoom-scale]="'page-fit'" [original-size]="false" style="width: 100%; height: 100%"
            [zoom]="pdfZoom" [(page)]="pdfPages" (pages-initialized)="onPageLoad($event)">
        </pdf-viewer>
    </div>
</div>
<div class="dialog" [style.width]="'810px'" [style.height]="'100%'" [style.padding]="'10px'">
    <div class="dialog-header">【交工报检单】补充信息</div>
    <div class="dialog-body">
        <div class="grid">
            <div class="row">
                <div class="column background-page" [style.width]="80 + 'px'">
                    <span class="color-danger">*</span> 交工部位
                </div>
                <div class="column required" [style.width]="100 + 'px'">
                    <select class="color-primary background-module" [(ngModel)]="sectionId" [disabled]="true">
                        <option *ngFor="let item of sectionList" [value]="item.id">{{item.name}}</option>
                    </select>
                </div>
                <div class="column required" [style.width]="586 + 'px'">
                    <nz-cascader class="color-primary" [nzShowSearch]="true" [nzOptions]="jgFbCascaderOptions"
                        [(ngModel)]="jgFbCascaderValue" (ngModelChange)="onFbCascaderValueChange()">
                    </nz-cascader>
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="80 + 'px'">
                    <span class="color-danger">*</span> 检查项目
                </div>
                <div class="column required" [style.width]="686 + 'px'">
                    <nz-cascader class="color-primary" [nzShowSearch]="true" [nzOptions]="jgFxCascaderOptions"
                        [(ngModel)]="jgFxCascaderValue" (ngModelChange)="onUnitFxItemChoose()">
                    </nz-cascader>
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="80 + 'px'">
                    <span class="color-danger">*</span> 报检批次
                </div>

                <div class="column required" [style.width]="100 + 'px'">
                    <input type="text" [(ngModel)]="record.docSnNo" placeholder="输入报检批次">
                </div>
                <div class="column color-light" [style.width]="586 + 'px'">
                    3位数字：（单位工程，交工分部，分项工程，检测项目）空间内的序号
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="80 + 'px'">
                    提交日期
                </div>
                <div class="column" [style.width]="686 + 'px'">
                    <nz-date-picker [nzSuffixIcon]="''" nzPlaceHolder=" 输入表单生成并提交签字的日期" nzFormat="yyyy-MM-dd"
                        [(ngModel)]="record.docSubmitDateDate">
                    </nz-date-picker>
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="80 + 'px'">
                    <span class="color-danger">*</span> 完成日期
                </div>
                <div class="column required" [style.width]="686 + 'px'">
                    <nz-date-picker [nzSuffixIcon]="''" nzPlaceHolder=" 输入表单签字盖章完成的日期" nzFormat="yyyy-MM-dd"
                        [(ngModel)]="record.docFinishDateDate">
                    </nz-date-picker>
                </div>
            </div>
        </div>
        <div *ngIf="!!fxItem?.id" class="grid" [style.marginTop]="'1rem'">
            <div class="row">
                <div class="column background-page text-right" [style.width]="186 + 'px'">
                    起止里程桩号：
                </div>
                <div class="column" [style.width]="170 + 'px'">
                    <input type="text" placeholder="输入起始里程桩号" [(ngModel)]="mileStart">
                </div>
                <div class="column background-module" [style.width]="20 + 'px'">
                    ～
                </div>
                <div class="column" [style.width]="170 + 'px'">
                    <input type="text" placeholder="输入终止里程桩号" [(ngModel)]="mileEnd">
                </div>
                <div class="column background-page" [style.width]="70 + 'px'">
                    <button nz-button nzType="primary" (click)="onLcSearch()">
                        查询
                    </button>
                </div>
                <div class="column background-page" [style.width]="70 + 'px'">
                    <button nz-button nzType="primary" (click)="reset()">
                        复位
                    </button>
                </div>
                <div class="column background-page" [style.width]="80 + 'px'">
                    <label>
                        <input type="checkbox" [(ngModel)]="checkAll" (ngModelChange)="onCheckAllChange()">
                        全选
                    </label>
                </div>
            </div>
        </div>
        <div class="grid table-container" [style.height]="'calc(100vh - 23rem)'" [style.width]="'100%'"
            *ngIf="!!fxItem?.id">
            <div class="table-wrapper" (scroll)="onScroll($event)" (scrollend)="onScrollEnd($event)" #scroll>
                <table-pro [config]="config!" [currentPage]="1" [currentPageSize]="1000" [tableData]="[]"
                    [stickyTop]="0">
                    <div body>
                        <table [style.left]="0" [style.width]="totalWidth + 'px'">
                            <colgroup>
                                <col span="1" [style.width]="(56 * 100 / totalWidth) + '%'">
                                <col span="1" *ngFor="let col of config?.columns ?? []"
                                    [style.width]="(col.width * 100 / totalWidth) + '%'">
                            </colgroup>
                            <tr class="{{index < recordTable.length - 1 && (item.fullName + (item.partitionCode ?? '')) !== (recordTable[index + 1].fullName + (item.partitionCode ?? '')) ? 'border-bottom-black' : ''}}"
                                *ngFor="let item of recordTable ?? []; let index = index;">
                                <td [style.textAlign]="'center'">
                                    {{index + (pager.pageIndex - 1) * pager.pageSize + 1}}</td>

                                <td class="border-bottom-black background-white border-right-black" *ngIf="item.fbCode"
                                    [rowSpan]="item.fbSpan ?? 1">
                                    <span class="color-light">{{item.fbCode}}</span> {{item.fbName}}
                                </td>
                                <td class="border-bottom-black background-white" *ngIf="item.subFbCode"
                                    [rowSpan]="item.subFbSpan ?? 1">
                                    <b> <span class="color-light">{{item.subFbCode}}</span>
                                        {{item.subFbName}}</b>
                                </td>
                                <td class="{{isLM ? 'background-white border-bottom-black' : ''}}"
                                    *ngIf="isLM && item.sectionCode || !isLM" [rowSpan]="item.sectionSpan ?? 1">
                                    <p class="ellipsis" dPopover [content]="item.sectionCode + ' ' + item.sectionName"
                                        [trigger]="'hover'" [position]="['bottom','top', 'right',  'left']"
                                        [controlled]="(item.sectionCode + ' ' + item.sectionName).length > 25"
                                        [popoverStyle]="{ backgroundColor: 'white', color: '#1C53D9' }"
                                        [appendToBody]="true">
                                        <span class="color-grey">{{item.sectionCode}}</span> {{item.sectionName}}
                                    </p>
                                </td>
                                <td class="text-center" *ngIf="isLM && item.code" [rowSpan]="item.codeSpan ?? 1">
                                    {{item.code}}
                                </td>
                                <td class="text-center" *ngIf="isLM && item.code" [rowSpan]="item.codeSpan ?? 1">
                                    {{item.mileage}}
                                </td>
                                <td class="color-light text-center" *ngIf="isLM && item.code || !isLM"
                                    [rowSpan]="item.codeSpan ?? 1">
                                    {{item.constructionOrgName}}
                                </td>
                                <td class="color-light" *ngIf="isLM && item.code || !isLM"
                                    [rowSpan]="item.codeSpan ?? 1" [style.textAlign]="'center'">
                                    <span *ngIf="item.constructionFormCompleted" class="color-success">齐全</span>
                                    <span *ngIf="!item.constructionFormCompleted" class="color-primary">
                                        {{item.constructionFormUploadedCount}}
                                    </span>
                                    <span *ngIf="!item.constructionFormCompleted" class="color-grey">
                                        /
                                    </span>
                                    <span *ngIf="!item.constructionFormCompleted">
                                        {{item.constructionFormCount}}
                                    </span>
                                </td>
                                <td class="color-light" *ngIf="isLM && item.code || !isLM"
                                    [rowSpan]="item.codeSpan ?? 1" [style.textAlign]="'center'">
                                    <span *ngIf="item.superviseRecordFormCompleted" class="color-success">齐全</span>
                                    <span *ngIf="!item.superviseRecordFormCompleted" class="color-primary">
                                        {{item.superviseRecordFormUploadedCount}}
                                    </span>
                                    <span *ngIf="!item.superviseRecordFormCompleted" class="color-grey">
                                        /
                                    </span>
                                    <span *ngIf="!item.superviseRecordFormCompleted">
                                        {{item.superviseRecordFormCount}}
                                    </span>
                                </td>
                                <td [style.textAlign]="'center'">
                                    <input *ngIf="!item.jgRfiWorkFlowKey" type="checkbox" [(ngModel)]="item.checked"
                                        (ngModelChange)="onCheckChange()">
                                    <span *ngIf="item.jgRfiWorkFlowKey"
                                        class="pointer link {{ProjectSectionUnitJgStatusColorMap[item.jgStatus!]}}"
                                        (click)="sign(item.jgRfiWorkFlowKey)">
                                        {{item.jgRfiName}}
                                    </span>
                                </td>
                            </tr>

                        </table>

                    </div>
                </table-pro>
            </div>
        </div>
    </div>
    <div class="dialog-footer">
        <button nz-button nzType="default" (click)="cancel()">取消</button>
        <button nz-button nzType="primary" (click)="confirm()" [disabled]="!canConfirm">确认</button>
    </div>
</div>